module.exports = __webpack_public_path__ + "static/marketing-pro-hero-bg-e456d1e8fdeca3c520521c2b96aa92da.jpg";